import { Injectable } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { format, parse, isValid } from 'date-fns';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (date) {
      return format(date, 'dd-MMM-yyyy');
    }
    return '';
  }

  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.trim()) {
      // Try to parse dd-MMM-yyyy format
      const parsed = parse(value, 'dd-MMM-yyyy', new Date());
      if (isValid(parsed)) {
        return parsed;
      }
      
      // Try to parse dd/MM/yyyy format
      const parsed2 = parse(value, 'dd/MM/yyyy', new Date());
      if (isValid(parsed2)) {
        return parsed2;
      }
      
      // Try to parse yyyy-MM-dd format
      const parsed3 = parse(value, 'yyyy-MM-dd', new Date());
      if (isValid(parsed3)) {
        return parsed3;
      }
    }
    return super.parse(value);
  }
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'dd-MMM-yyyy',
  },
  display: {
    dateInput: 'dd-MMM-yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd-MMM-yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
}; 